export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

// export const toAbsoluteUrl = (pathname: string) => {
//   // si es algo del media global, no le agregues PUBLIC_URL
//   if (pathname.startsWith('/media/')) {
//     return pathname;
//   }
//   // para los assets internos del front
//   return process.env.PUBLIC_URL + pathname;
// };
